import CrudRepository from './CrudRepository'
export default class NumberIndoRepository extends CrudRepository {
  constructor () {
    super('core/api/users/numberInfo')
  }
}
